import axios from "axios";
import { useQuery } from "react-query";
import { API_ENDPOINT, APP_ID } from "../utils/constants";

const useGetEmailTemplate = () => {
  return useQuery({
    queryKey: ["get-email-template", APP_ID],
    queryFn: async () => {
      const response = await axios.get(
        `${API_ENDPOINT}event/get-email-template`,
        {
          headers: {
            dbauth: APP_ID, // Send token securely in headers
          },
        }
      );
      return response.data;
    },
    retry: (failureCount, error) => {
      if (!error.response) return true; // Retry on network errors
      const status = error.response.status;
      return status !== 401 && status !== 404 && status !== 500; // No retries for 404/500
    },
  });
};

export default useGetEmailTemplate;
